export const ClickCollect = 'clickCollect';
export const ClickDeliver = 'clickDeliver';
export const DeliveryArrangements = 'deliveryArrangements';
export const MovingProducts = 'movingProducts';
export const ReinitializeCheckout = 'reinitializeCheckout';
export const FetchedShoppingLists = 'fetchedShoppingLists';
export const GetShoppingLists = 'getShoppingLists';
